import codeMasterModel from "../../models/common/code-master.model";
import MultiSelectComponent from "../multi-select/multi-select.component";
import SingleSelectComponent from "../single-select/single-select.component";

/**
 * A Select component by Code Master category
 * 
 * @author CV Leong
 */
export default function SelectCodeMasterCategoryComponent() {
  let selectOptions = [];

  return {
    oninit: ({ attrs: { category } }) => {
      codeMasterModel.getByCategoryV2({ category })
        .then(data => {
          selectOptions = data || [];
        })
    },
    view: ({ attrs: { items, isMultiple = true, ...props } }) => {
      return [
        isMultiple
          ? m(MultiSelectComponent, {
            items: selectOptions,
            ...props,
          })
          : m(SingleSelectComponent, {
            items: selectOptions,
            ...props,
          })
      ]
    }
  }
}